module.exports = __webpack_public_path__ + "static/media/LiDARMill_byPhoenix.344ab6ed.svg";